import { JoinRoomResponseType } from '../../types/JoinRoomResponse'

export const JoinRoomResponse: JoinRoomResponseType = {
  id: 'ROOM_ID',
  roomToken:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.2uZb3lubeFDSTgUUBUMyQ6ogsSY0r6HFtxM_LvKVpBQ'
}
